;(() => {
    const links = document.querySelectorAll('.js-locked-link')

    links.forEach(link => {
        link.addEventListener('click', e => e.preventDefault())
    })
})()
